const notificationsEvents = {
  hints: {
    balance: {
      limit: {
        balance: 'Notify when balance is {amount}',
        onLimit: 'When balance is',
        onNullBalance: 'Notify when balance is zero',
        noLimit: '<not specified>',
        notifyBy: 'notify via',
        noNotifications: '<no method selected>',
        overdraft: ' + user overdraft',
        extraRecipients: 'Notifications on the balance status of all users of the system',
        invoice: 'Attach invoice for the amount {amount}'
      }
    }
  },
  labels: {
    balance: {
      limit: {
        host: 'Host',
        port: 'Port',
        from: 'From',
        login: 'Login',
        password: 'Password',
        limit: 'Limit',

        include: {
          overdraft: 'Including overdraft',
          invoice: 'Detach invoice for {amount}'
        },

        notInclude: {
          overdraft: 'Not including overdraft',
          invoice: 'Do not send invoice'
        },

        invoice: {
          amount: 'Invoice amount'
        }
      }
    },
    providers: {
      health: {
        recipients: 'Provider health notifications recipients'
      }
    }
  },
  buttons: {
    balance: {
      limit: {
        invoice: {
          attach: 'Attach invoice',
          detach: 'Detach invoice'
        }
      }
    }
  }
}

export default {
  title: 'User settings',

  titles: {
    sendings: 'Sendings',
    billings: 'Billings',
    referral: 'Referral',
    websocket: 'Websocket',
    smpp: 'SMPP',
    webhooks: 'Webhooks',
    notifications: 'Notifications',
    statuses: 'Mapping statuses',
    integrations: 'Integrations'
  },

  subtitles: {
    sendings: {
      duplicates: 'Duplicates',
      rateLimit: 'Rate limiting'
    },

    billings: {
      autoAccrual: 'Auto accrual',
      processChildrenOperations: 'Process children operations'
    },

    referral: {
      billings: {
        processedChildOperations: 'Billings operations'
      }
    },

    webhooks: {
      general: 'General',
      successOn: 'Conditions for successful request'
    },

    integrations: {
      pyrus: {
        credentials: 'Pyrus credentials'
      },
      yclients: {
        applicationCredentials: 'Application credentials'
      }
    },

    notifications: {
      events: {
        balance: {
          limit: 'Balance limit'
        }
      }
    }
  },

  dialogs: {
    titles: {
      webhooks: {
        onStatusChange: 'On status change',
        onIncomingMessage: 'Incoming'
      }
    }
  },

  hints: {
    billings: {
      overdraft: {
        negative: '<strong>WARNING!<br>New overdraft value will not allow user to send messages.</strong>'
      }
    },

    webhooks: {
      onStatusChange: 'Define webhook that will be fired on each message status change',
      onIncomingMessage: 'Define webhook that will be fired on incoming message'
    },

    referral: {
      billings: {
        processedChildOperations: {
          limits: 'Limits - the minimum and maximum amount of guaranteed reward for each referral transaction.'
        }
      }
    },

    notifications: {
      events: notificationsEvents.hints,
      childrenUsersEvents: notificationsEvents.hints
    },

    smpp: {
      ipAddresses: 'Only valid IP addresses, delimiter "comma" or "line break".'
    },

    warning: 'Changing settings does not require user update.'
  },

  labels: {
    sendings: {
      allowDuplicates: 'Allow duplicates',
      duplicates: {
        hashFields: 'Fields for duplicate checking',
        timeout: 'Duplicate timeout'
      },
      rateLimit: {
        maxAmount: 'Message amount',
        timeout: 'Timeout'
      },
      tilda: {
        sendFromForms: 'Allow send message from Tilda forms'
      }
    },

    billings: {
      autoAccrual: {
        limit: 'Limit',
        requiredBalance: 'Required balance'
      },
      overdraft: 'Overdraft',
      processChildrenOperations: 'Process children account operations as own',
      billOnErrors: 'Bill SMS in case of errors',
      currency: 'Currency'
    },

    referral: {
      billings: {
        processedChildOperations: {
          source: 'Source',
          percent: 'Percent',
          limitMin: 'Min limit',
          limitMax: 'Max limit'
        }
      }
    },

    smpp: {
      enabled: 'SMPP enabled',
      rudeMode: 'SMPP rude mode',
      defaultMessageType: 'SMPP default message type',
      ipWhitelist: 'Whitelist',
      ipAddresses: 'IP addresses',
      confirm: 'Confirm save'
    },

    webhooks: {
      title: 'Message status change',
      url: 'Request URL',
      method: 'Request method',
      headers: 'Request headers',
      body: 'Request body',
      maxConnections: 'Maximum connections amount',
      successOn: {
        status: 'Regexp check on status',
        body: 'Regexp check on response body'
      }
    },

    notifications: {
      extraRecipients: 'Notification Recipients',
      type: 'Type notification',
      events: notificationsEvents.labels,
      childrenUsersEvents: notificationsEvents.labels
    },

    websocket: {
      channels: 'Channels'
    },

    integrations: {
      pyrus: {
        credentials: {
          login: 'Login',
          security_key: 'Security key'
        }
      }
    }
  },

  buttons: {
    notifications: {
      events: notificationsEvents.buttons,
      childrenUsersEvents: notificationsEvents.buttons
    }
  },

  contents: {
    webhooks: {
      onStatusChange: 'On status change',
      onIncomingMessage: 'Incoming',
      statuses: 'Statuses'
    }
  },

  warnings: {
    smpp: {
      ipAddresses: 'Some of the entered IP addresses failed the validity check.<br>If you need to keep these addresses, make sure they are correct, then re-enter them in the "IP addresses" field and click "Save"<br>If the addresses are still invalid, this dialog will remain open, and the list below will update with the new invalid addresses.'
    }
  },

  items: {
    websocket: {
      channels: {
        dbUpdates: 'DB update',
        everything: 'Everything',
        health: 'Health',
        sendingStatusUpdates: 'Sending status updates',
        providersStatesUpdates: 'Providers states updates'
      }
    }
  },

  snackbars: {
    updated: 'Setting successfully updated.'
  }
}
